/**
 * Searchable finance-scheme picker — shared by the ICE/EV quote editors and
 * the standalone Finance (EMI) tab. Type to filter by product id or terms.
 */
import { useState } from "react";

const schemeLabel = (s) =>
  `${s.product_id} — ${Math.round((s.down_payment_pct || 0) * 100)}% down · ${s.tenure}m · ${s.rate_interest}% flat`;

export function FinanceSchemePicker({ schemes, value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = schemes.find((s) => s.id === value);
  const needle = q.trim().toLowerCase();
  const matches = needle
    ? schemes.filter((s) => schemeLabel(s).toLowerCase().includes(needle))
    : schemes;
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => { setOpen((o) => !o); setQ(""); }}
        data-testid={testId}
        className="input w-full text-left truncate"
      >
        {selected ? schemeLabel(selected) : "— pick scheme —"}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute z-40 left-0 right-0 mt-1 border border-canvas-line bg-canvas shadow-lg">
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search product id / % / tenure…"
              data-testid={`${testId}-search`}
              className="w-full px-2 py-1.5 border-b border-canvas-line text-sm focus:outline-none"
            />
            <div className="max-h-52 overflow-y-auto">
              {matches.length === 0 ? (
                <div className="px-2 py-3 text-xs text-ink-muted">No scheme matches “{q}”.</div>
              ) : (
                matches.map((s) => (
                  <button
                    type="button"
                    key={s.id}
                    onClick={() => { onChange(s.id); setOpen(false); setQ(""); }}
                    data-testid={`${testId}-option-${s.product_id}`}
                    className={`w-full text-left px-2 py-1.5 text-sm hover:bg-canvas-panel ${s.id === value ? "bg-canvas-panel font-medium" : ""}`}
                  >
                    <span className="font-mono">{s.product_id}</span>
                    <span className="text-ink-muted"> — {Math.round((s.down_payment_pct || 0) * 100)}% down · {s.tenure}m · {s.rate_interest}% flat</span>
                  </button>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
